__turbopack_context__.v({
  "asc": "tableHeader-module-scss-module__tKmN5W__asc",
  "bold": "tableHeader-module-scss-module__tKmN5W__bold",
  "center": "tableHeader-module-scss-module__tKmN5W__center",
  "desc": "tableHeader-module-scss-module__tKmN5W__desc",
  "down": "tableHeader-module-scss-module__tKmN5W__down",
  "icon": "tableHeader-module-scss-module__tKmN5W__icon",
  "left": "tableHeader-module-scss-module__tKmN5W__left",
  "right": "tableHeader-module-scss-module__tKmN5W__right",
  "sorted": "tableHeader-module-scss-module__tKmN5W__sorted",
  "sorting": "tableHeader-module-scss-module__tKmN5W__sorting",
  "subColumns": "tableHeader-module-scss-module__tKmN5W__subColumns",
  "title": "tableHeader-module-scss-module__tKmN5W__title",
  "tooltip": "tableHeader-module-scss-module__tKmN5W__tooltip",
  "up": "tableHeader-module-scss-module__tKmN5W__up",
  "wrapper": "tableHeader-module-scss-module__tKmN5W__wrapper",
});
